/**
 * The last steps of starting playback, for the device debug server
 * (`window.__sliqueDebug.playTrace()`, debug/deviceState.ts).
 *
 * WHY (2026-10-20): on the onn box, Play Now pressed right after a cold start
 * filled the screen and nothing ever played: no error anywhere, and the native
 * player never heard of the film. Something in between waited forever, and only
 * a step-by-step record taken on the box could say which step.
 *
 * Step names and times only, plus a title: never a stream address, which carries
 * the provider login.
 */

export interface PlayTraceStep {
  /** Milliseconds since the page started (performance.now), so steps line up with the start-up trace. */
  at: number;
  step: string;
  detail?: string;
}

const MAX_STEPS = 60;
const steps: PlayTraceStep[] = [];

export function tracePlay(step: string, detail?: string): void {
  steps.push({ at: Math.round(performance.now()), step, ...(detail ? { detail: detail.slice(0, 80) } : {}) });
  if (steps.length > MAX_STEPS) steps.shift();
}

export function playTrace(): PlayTraceStep[] {
  return steps.slice();
}
